const state = {
  preloaderVisible: false
};

const getters = {
  preloaderVisible: state => {
    return state.preloaderVisible;
  }
};

const mutations = {
  changePreloaderVisible: (state, newItem) => {
    state.preloaderVisible = newItem;
  }
};

export default {
  state,
  getters,
  mutations
};



//////////////////
// WEBPACK FOOTER
// ./store/modules/preloader.js
// module id = null
// module chunks = 